import { TAction } from '../../../common/types';
import { TBookSettings } from '../../../common/rest/endlessBook/endlessBookRest';

export const BOOKS_SET_CREATING = 'BOOKS/SET_CREATING';
export const BOOKS_SET_REGENERATING = 'BOOKS/SET_REGENERATING';
export const BOOKS_BUMP_RELOAD = 'BOOKS/BUMP_RELOAD';
export const BOOKS_SET_SETTINGS = 'BOOKS/SET_SETTINGS';
export const BOOKS_SET_HOST = 'BOOKS/SET_HOST';

export interface IBooksState {
	// by audioId: the lesson's book is being created
	creating: Record<number, boolean>;
	// by bookId
	regenerating: Record<number, boolean>;
	// by bookId: bumped after a regenerate so the reader remounts on the new page 1
	reloadKey: Record<number, number>;
	// by bookId: the book's current generation settings, as the reader loaded them
	settings: Record<number, TBookSettings>;
	// endless-book origin the reader talks to; known after the first token fetch
	bookHost: string | null;
	// the token fetch that would bring bookHost failed — the tab offers a retry
	bookHostFailed: boolean;
}

export interface ISetBookCreatingAction extends TAction<typeof BOOKS_SET_CREATING> {
	audioId: number;
	creating: boolean;
}

export interface ISetBookRegeneratingAction extends TAction<typeof BOOKS_SET_REGENERATING> {
	bookId: number;
	regenerating: boolean;
}

export interface IBumpBookReloadAction extends TAction<typeof BOOKS_BUMP_RELOAD> {
	bookId: number;
}

export interface ISetBookSettingsAction extends TAction<typeof BOOKS_SET_SETTINGS> {
	bookId: number;
	settings: TBookSettings;
}

export interface ISetBookHostAction extends TAction<typeof BOOKS_SET_HOST> {
	bookHost: string | null;
	failed: boolean;
}

export type TBooksActions =
	| ISetBookCreatingAction
	| ISetBookRegeneratingAction
	| IBumpBookReloadAction
	| ISetBookSettingsAction
	| ISetBookHostAction;
